// extracted by mini-css-extract-plugin
export default {"copy-button":"styles_copy-button__pTLQR","lowercase":"styles_lowercase__VBPua"};